
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type MoveBreakPayload = {
  stopId: EntityId
  targetStopId: EntityId
}

export const moveBreak = createAsyncThunk<void, MoveBreakPayload, { state: RootState }>(
  'dragdrop/moveBreak',
  async (payload, { getState }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/moveBreak' : '/runsheet/moveBreak'

    await OLMSApiService.post<null>(endpoint, payload)
  },
)
